import { Textarea } from "@mantine/core";
import { useForm, Controller } from "react-hook-form";
import { WorkflowButton as CommentButton } from "../Buttons";
import { useAccessRequest } from "@/context/access-request-context";
import { useAuth } from "@/context/auth-context";

export default function CommentForm({ taskId, processId }: { taskId: string, processId: string }) {
	const { postComment, postingComment, requestDetails } = useAccessRequest();
	const { appUser } = useAuth();
	const {
		control,
		handleSubmit,
		formState: { errors },
    reset
	} = useForm({ mode: "all" });

	const submitForm = async ({ comment }: { comment: string }) => {
		const payload: CreateComment = {
			comment,
			taskId,
      processId,
			requestId: requestDetails?.id,
			email: appUser?.email
		};
    
		await postComment(payload);
    reset({ comment: "" });
	};

	return (
		<>
			<div className="md:w-1/2">
				<form onSubmit={handleSubmit(submitForm)}>
					<Controller
						name="comment"
						control={control}
						rules={{
							required: "Comment is required",
						}}
						render={({ field: { value, onBlur, onChange, ref } }) => (
							<Textarea
								placeholder="Type comment"
								name="comment"
								id="comment"
								value={value}
								onChange={onChange}
								onBlur={onBlur}
								ref={ref}
							/>
						)}
					/>
					{errors?.comment?.message && (
						<div className="mt-2 text-red-600 text-[12px]">
							{errors.comment.message}
						</div>
					)}
					<CommentButton
						title="Add Comment"
						type="submit"
						loading={postingComment}
						disabled={postingComment}
						className="mt-4 text-sm rounded-md 
            cursor-pointer px-4 py-2 bg-primaryGreen 
            text-white hover:bg-primaryGreen-300 
            hover:text-white"
					/>
				</form>
			</div>
		</>
	);
}
